const SELF_RPP_TRIGGER =
  '.dialog-table-paginator-dropdown-self .p-paginator-rpp-dropdown';

/** Fields this hook reads from PrimeNG's overlay animation callback. */
interface OverlayAnimationStart {
  toState?: string;
  element?: HTMLElement;
}

/**
 * Rows-per-page menus mounted with appendTo self inside a dialog are placed
 * by PrimeNG against the viewport. When the menu would run past the bottom of
 * the scrolling dialog content (adding a scrollbar, and closing the menu as
 * soon as that content scrolls), open it above the control instead.
 */
export function flipDialogPaginatorDropdown(
  event?: OverlayAnimationStart,
): void {
  if (event?.toState !== 'visible') {
    return;
  }
  const wrapper = event.element?.parentElement;
  if (!(wrapper instanceof HTMLElement)) {
    return;
  }
  const trigger = wrapper.closest(SELF_RPP_TRIGGER);
  const content = trigger?.closest('.p-dialog-content');
  const offsetParent = wrapper.offsetParent;
  if (!trigger || !content || !offsetParent) {
    return;
  }

  const height = wrapper.offsetHeight;
  const triggerRect = trigger.getBoundingClientRect();
  const contentRect = content.getBoundingClientRect();
  const spaceBelow = contentRect.bottom - triggerRect.bottom;
  const spaceAbove = triggerRect.top - contentRect.top;
  if (height <= spaceBelow || height > spaceAbove) {
    return;
  }

  const parentTop = offsetParent.getBoundingClientRect().top;
  wrapper.style.top = `${Math.round(triggerRect.top - parentTop - height)}px`;
  wrapper.style.transformOrigin = 'center bottom';
  wrapper.style.marginTop = 'calc(var(--p-anchor-gutter) * -1)';
}
